/**
 * @generated SignedSource<<a834be52143a281137a9b05407d13957>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateImageWithButtonPageInput = {
  clientMutationId?: string | null;
  image: string;
  internalTitle: string;
  messageDefinitionId: string;
};
export type useMessagePageMutations_CreateImageButtonPageMutation$variables = {
  input: CreateImageWithButtonPageInput;
};
export type useMessagePageMutations_CreateImageButtonPageMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly createImageWithButtonPage: {
        readonly messageDefinition: {
          readonly node: {
            readonly id: string;
          };
        };
        readonly pageId: string;
      } | null;
    };
  };
};
export type useMessagePageMutations_CreateImageButtonPageMutation = {
  response: useMessagePageMutations_CreateImageButtonPageMutation$data;
  variables: useMessagePageMutations_CreateImageButtonPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageDefinitionsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "MessageDefinitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "CreateImageWithButtonPagePayload",
            "kind": "LinkedField",
            "name": "createImageWithButtonPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDefinitionsEdge",
                "kind": "LinkedField",
                "name": "messageDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageDefinition",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageMutations_CreateImageButtonPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMessagePageMutations_CreateImageButtonPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "51bc2c84520ba6b806f74a9223df94e5",
    "id": null,
    "metadata": {},
    "name": "useMessagePageMutations_CreateImageButtonPageMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageMutations_CreateImageButtonPageMutation(\n  $input: CreateImageWithButtonPageInput!\n) {\n  Admin {\n    MessageDefinitions {\n      createImageWithButtonPage(input: $input) {\n        pageId\n        messageDefinition {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f5c8c7667fe48377274796fd4be5b9c";

export default node;
